export function isOffseason(league: string, date: Date = new Date()): boolean {
    const month = date.getMonth(); // 0 = January, 11 = December
  
    switch (league.toLowerCase()) {
      case 'mlb':
        // Active: April (3) to October (9)
        return month < 3 || month > 9;
      case 'nba':
      case 'nhl':
        // Active: October (9) to June (5) [Playoffs finish mid-June]
        return month > 5 && month < 9; // July(6), August(7), September(8)
      case 'nfl':
        // Active: September (8) to February (1)
        return month > 1 && month < 8; // March(2) - August(7) are offseason
      default:
        return false;
    }
  }
  